import { Flex } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import companyAnalysisTrackingService from "app/pages/sales-intelligence/modules/company-analysis/services/tracking/companyAnalysisTrackingService";
import { COMPANY_ANALYSIS_TAB_NAMES } from "app/pages/sales-intelligence/pages/company-analysis/constants";
import { COMPANY_ANALYSIS_COMPETITORS } from "app/pages/sales-intelligence/constants/routes";
import { useCompanyName } from "app/pages/sales-intelligence/modules/company-analysis/hooks/useCompanyName";
import useCompetitorsQuery from "app/pages/sales-intelligence/modules/company-analysis/queries/useCompetitorsQuery";
import CompetitorsCardContent from "app/pages/sales-intelligence/pages/company-analysis/components/cards/competitors-card/CompetitorsCardContent/CompetitorsCardContent";
import CompetitorsCardLoader from "app/pages/sales-intelligence/pages/company-analysis/components/cards/competitors-card/CompetitorsCardLoader/CompetitorsCardLoader";
import Card from "app/pages/sales-intelligence/pages/company-analysis/components/shared/Card/Card";
import CardFooter from "app/pages/sales-intelligence/pages/company-analysis/components/shared/Card/CardFooter/CardFooter";
import CardHeader from "app/pages/sales-intelligence/pages/company-analysis/components/shared/Card/CardHeader/CardHeader";

const CompetitorsCard = () => {
    const { data, isLoading, isFetched } = useCompetitorsQuery({ limit: 5, includeSignalsCount: true });
    const isEmpty = (!data || data.length === 0) && isFetched;

    const companyName = useCompanyName();

    const renderContent = () => {
        if (isLoading) {
            return <CompetitorsCardLoader />;
        }

        return (
            <Flex
                justifyContent="flex-start"
                flexGrow="1"
                flexDirection="column"
                flexWrap="wrap"
                padding="8px 24px"
                gap="8px"
                minHeight="316px"
            >
                <CompetitorsCardContent competitors={data} />
            </Flex>
        );
    };

    return (
        <Card
            dataAutomation="competitors-card"
            isEmpty={isEmpty}
            header={
                <CardHeader
                    title={translate("si.company-analysis.competitors.card.header")}
                    infoTooltip={translate("si.company-analysis.competitors.card.header.info-tooltip")}
                />
            }
            footer={
                <CardFooter
                    stateId={COMPANY_ANALYSIS_COMPETITORS}
                    isLoading={isLoading}
                    onClick={() => {
                        companyAnalysisTrackingService.widgets.trackWidgetFooterButtonClick(
                            companyName,
                            COMPANY_ANALYSIS_TAB_NAMES.competitors,
                        );
                    }}
                />
            }
            renderContent={renderContent}
            width="50%"
        />
    );
};

export default CompetitorsCard;
